"use client";

import React from "react";
import { useCookieConsent } from "@/lib/cookie-consent";
import { X } from "lucide-react";

const CookieBanner: React.FC = () => {
  const { showBanner, acceptAll, rejectAll, setShowModal } = useCookieConsent();

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 right-0 z-50 max-w-md w-full sm:w-auto sm:bottom-8 sm:right-8 bg-black text-white shadow-lg">
      <div className="relative p-4 sm:p-6">
        <button
          onClick={() => rejectAll()}
          className="absolute top-3 right-3 p-1 hover:bg-[#252525] rounded-full transition-colors"
          aria-label="Close cookie banner"
        >
          <X className="w-4 h-4" />
        </button>

        <p className="text-sm mb-4 pr-6">
          This website uses cookies, pixel tags, and local storage for
          performance, personalization, and marketing purposes. We use our own
          cookies and some from third parties. Only essential cookies are turned
          on by default.
        </p>

        <div className="text-sm mb-4 sm:mb-6">
          <button
            onClick={() => setShowModal(true)}
            className="text-white underline hover:no-underline"
          >
            Cookies settings
          </button>
        </div>

        <div className="flex flex-col gap-2 w-full">
          <button
            onClick={acceptAll}
            className="w-full py-2 sm:py-3 bg-white text-black hover:bg-gray-200 transition-colors text-sm font-medium"
          >
            Allow all cookies
          </button>
          <button
            onClick={rejectAll}
            className="w-full py-2 sm:py-3 text-center text-white hover:underline transition-colors text-sm font-medium"
          >
            Do not allow cookies
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
